import { getLocalStorageItem } from "./Localstorage/localStorageUtils";

export const PrivilegesViewChecker = (parentData) => {
  try {
    const userDataRaw = getLocalStorageItem('userData');
    let userData;
    if (typeof userDataRaw === 'string') {
      try {
        userData = JSON.parse(userDataRaw);
      } catch {
        userData = null;
      }
    } else {
      userData = userDataRaw;
    }
    if (!userData) return false;

    const Group = userData?.Group;
    const role = userData?.role?.toLowerCase();
    if (role === "admin") return true;

    if (role === "user") {
      const privilege = Group.privileges?.[parentData];
      if (privilege === "Can view" || privilege === "Can create") {
        return true;
      }
    }
  } catch (error) {
    console.error("Error parsing user data:", error);
  }
  return false;
};

export const PrivilegesChecker = (parentData) => {
  try {
    const userDataRaw = getLocalStorageItem('userData');
    let userData;
    if (typeof userDataRaw === 'string') {
      try {
        userData = JSON.parse(userDataRaw);
      } catch {
        userData = null;
      }
    } else {
      userData = userDataRaw;
    }
    if (!userData) return false;

    const Group = userData?.Group;
    const role = userData?.role?.toLowerCase();
    if (role === "admin") return true;

    if (role === "user") {
      const privilege = Group.privileges?.[parentData];
      if (privilege === "Can create") {
        return true;
      }
    }
  } catch (error) {
    console.error("Error parsing user data:", error);
  }
  return false;
};
